import React, {useEffect, useState} from 'react';
import { ReactComponent as GroupIcon } from '../../../assets/main/groups/main-top/group.svg';
import { MainTop } from './group-container/main-top/Main-top';
import { GroupTable } from 'components/pages/groups/group-table/GroupTable';
import {useAppDispatch, useAppSelector} from "common/hook";
import { Navigate } from 'react-router-dom';
import AuthWrapper from "../../auth-wrapper/AuthWrapper";
import { fetchGroups } from "features/model/service/groups/fetchGroups";

export const Groups = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchGroups({}))
    }, [dispatch]);


    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Группы'} tabs={false} setting={false} link={'/groups'} icons={<GroupIcon />}/>
                <GroupTable />
            </div>
        </AuthWrapper>
    );
};
